var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 2H9.833C9.333 2 9 2.4 9 3s.333 1 .833 1h3.334c.5 0 .833-.4.833-1s-.333-1-.833-1zM4.375 0c-1.138 0-2.1.75-2.45 1.667H.875C.35 1.667 0 2 0 2.5c0 .5.35.833.875.833h1.05A2.66 2.66 0 004.375 5C5.862 5 7 3.917 7 2.5S5.862 0 4.375 0zM.833 11h3.334c.5 0 .833-.4.833-1s-.333-1-.833-1H.833C.333 9 0 9.4 0 10s.333 1 .833 1zM13.125 8.667h-1.05c-.35-1-1.313-1.667-2.45-1.667C8.137 7 7 8.083 7 9.5S8.137 12 9.625 12c1.137 0 2.1-.75 2.45-1.667h1.05c.525 0 .875-.333.875-.833 0-.5-.35-.833-.875-.833z",
    fill: "#1B143C"
  })));
}
export default SvgFilter;